var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('s-form',{attrs:{"cod":"10"},model:{value:(_vm.data.metadata),callback:function ($$v) {_vm.$set(_vm.data, "metadata", $$v)},expression:"data.metadata"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c1f7496","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/users/modal/metadata.vue
// module id = null
// module chunks = 